import {
  combine,
  withCallbacks,
  withContext,
  withMemo,
} from 'react-hooks-combine'
import { StoreContext } from 'store/context'
import { withTableController } from 'shared/hooks'
import TeamAthletesComponent from './component'
import { createColumns } from './columns.description'

export const TeamAthletes = combine(
  withTableController({ id: 'team-athletes-table' }),
  withContext('appStore', StoreContext),
  withMemo('columns', () => createColumns(), []),
  withCallbacks(
    {
      loadAthletes:
        ({ appStore }) =>
        async (tableState, _table, query) => {
          return appStore.adminTeams.loadTeamAthletes({
            name: query?.athletesName,
            sportType: query?.sportTypes,
            page: tableState.page,
            size: tableState.pageSize,
          })
        },
      onSearch:
        ({ table }) =>
        (query) => {
          table.search(query)
        },
    },
    []
  )
)(TeamAthletesComponent)
